// DeepReadonly type to prevent mutation on config object
// https://stackoverflow.com/questions/41879327/deepreadonly-object-typescript
type DeepReadonly<T> = T extends (infer R)[]
  ? DeepReadonlyArray<R>
  : T extends Function
  ? T
  : T extends object
  ? DeepReadonlyObject<T>
  : T;

interface DeepReadonlyArray<T> extends ReadonlyArray<DeepReadonly<T>> {}

type DeepReadonlyObject<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> };

const host = window.location.origin
  ? window.location.origin
  : window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');

const reviewsSize = 2;
const gqlBeforeNullCursor = '2DKB9g==';

const config = {
  apiHost: host + '/api',
  graphqlApiHost: host + '/graphql',

  mall: {
    reviews: {
      size: reviewsSize,
      startingCursor: gqlBeforeNullCursor,
    },
  },

  business: {
    reviews: {
      size: reviewsSize,
      startingCursor: gqlBeforeNullCursor,
    },
  },
};

const readonlyConfig: DeepReadonly<typeof config> = config;

export default readonlyConfig;
